<template>
  <button :class="{'selection-button': true, 'ri-large-body': true, selected}"
          :style="{'--selection-button-color': color}"
          @click.stop="onClick"
          :disabled="disabled">
    <span class="flex-row align-center">
      <span class="circle">
        <span class="selected-circle"></span>
      </span>
      <pre>{{ title }}</pre>
    </span>
  </button>
</template>

<script>
import Colors from '../scss/riseup-js-colors.module.scss';

export const SelectionButtonProps = {
  selected: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    required: false,
    default: Colors.riseupBlue,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
};

export default {
  name: 'SelectionButton',
  components: {
  },
  props: SelectionButtonProps,
  methods: {
    onClick(event) {
      this.$emit('select', event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/riseup-colors';
@import '../scss/typography';
@import "../scss/border-radius";
@import "../scss/spacings";
@import "./RiseupButton/riseup-button";

$selection-button-height: 72px;
$button-background-color: $riseup_white;

.selection-button {
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  height: $selection-button-height;
  width: 100%;
  border-radius: $button-border-radius;
  cursor: pointer;
  padding: 0 14px;
  border: 1px solid $riseup_gray_10;
  color: $riseup_black;
  background: $button-background-color;
  font-size: 14px;
  line-height: 16px;

  &.selected {
    color: var(--selection-button-color);
    font-weight: $ri-font-weight-bold;
    border: 1px solid var(--selection-button-color);

    .circle {
      border-color: var(--selection-button-color);
      .selected-circle {
        display: inline-block;
      }
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }

  &:not(:disabled):active {
    -webkit-filter: brightness(85%);
  }

  .circle {
    margin-left: 12px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid;
    border-color: $riseup_gray_10;
    flex-shrink: 0;

    .selected-circle {
      display: none;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      border: 3px solid $button-background-color ;
      background-color: var(--selection-button-color);
      box-sizing: border-box;
    }
  }

  pre {
    font-family: inherit;
    color: inherit;
    margin: 0;
    text-align: right;
  }
}
</style>
